var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "background"
  }, [_c('div', {
    staticClass: "ellipse vh-100 vw-100"
  }), _c('img', {
    staticClass: "login-picture",
    attrs: {
      "src": require("@/assets/images/login/login_picture.png"),
      "alt": "login picture"
    }
  }), _c('div', {
    staticClass: "login-card"
  }, [_c('custom-overlay', {
    attrs: {
      "loading": _vm.loading
    },
    scopedSlots: _vm._u([{
      key: "overlay-body",
      fn: function () {
        return [_c('div', {
          staticClass: "form-container"
        }, [_c('div', {
          staticClass: "header-container"
        }, [_c('div', {
          staticClass: "login-container"
        }, [_c('img', {
          staticClass: "logo",
          attrs: {
            "src": require("@/assets/cascade_basic_logo.svg"),
            "alt": "Cascade Logo"
          }
        }), _c('p', {
          staticClass: "login-text-header text-center"
        }, [_vm._v(" " + _vm._s(_vm.$t('login.header')) + " ")]), _c('p', {
          staticClass: "login-text text-center"
        }, [_vm._v(" " + _vm._s(_vm.$t('login.text')) + " ")])]), _c('selector', {
          staticClass: "language-selector"
        })], 1), _c('login-form', {
          staticClass: "login-form",
          attrs: {
            "error": _vm.loginError
          },
          on: {
            "submit": _vm.onSubmit
          }
        }), _c('div', {
          staticClass: "register text-center"
        }, [_c('span', [_vm._v(" " + _vm._s(_vm.$t('login.register-text')) + " ")]), _c('router-link', {
          staticClass: "register-link",
          attrs: {
            "to": {
              name: 'Signup'
            }
          }
        }, [_vm._v(" " + _vm._s(_vm.$t('signup.header')) + " ")])], 1)], 1)];
      },
      proxy: true
    }])
  })], 1)]);

}
var staticRenderFns = []

export { render, staticRenderFns }